import { render } from "./HealthCheckCount.vue?vue&type=template&id=beda666e"
import script from "./HealthCheckCount.vue?vue&type=script&lang=js"
export * from "./HealthCheckCount.vue?vue&type=script&lang=js"

import exportComponent from "/usr/src/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__